import { render, staticRenderFns } from "./InactivateLabelButton.vue?vue&type=template&id=2c8a1d59&"
import script from "./InactivateLabelButton.vue?vue&type=script&lang=js&"
export * from "./InactivateLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports